import { onMounted } from 'vue';
import ADBlockersDetector from 'a-detector-d';
import { notification } from 'ant-design-vue';

export function useAdBlockerDetector() {
  function detect() {
    onMounted(() => {
      ADBlockersDetector().then((res) => {
        res &&
          notification.warn({
            message: '缓慢的加载速度',
            description:
              '检测您可能正在使用 ADGuard 或者类似的浏览器插件，它们通常会跟踪每一条请求，为了达到最佳的用户体验，请关闭该插件！',
            duration: 0,
          });
      });
    });
  }

  return {
    detect,
  };
}
